import Vue from 'vue'
import Vuex from 'vuex'

// Global vuex
import media from './media'
import template from './template'
import project from './project'
import sceneDialog from './sceneDialog'
import scenes from './scenes'
import theme from './theme'
import audio from './audio'
import video from './video'
import psdLayers from './psd-layers'
import figmaLayers from './figma-layers'
import fileBrowser from './file-browser'
import layoutFolderBrowser from './layout-folder-browser'
import fileBrowserProductSelector from './file-browser-product-selector'
import fileUploadImages from './file-upload-images'
import svgEditor from './svg-editor';
import StoreSaver from "./plugins/store-saver";
import layout from './layout'
import dashboard from './dashboard'
import productDescription from './productDescription'
import walmart from './walmart'
import userNotification from './user-notification'
import bynder from './bynder'
import productImageSelector from './product-image-selector'
import mobileHeroSettings from './mobile-hero-settings';
import feedImportMapping from './feed-import-mapping';
import gridViewMemory from './layout-folder-browser/grid-view-memory';
import customers from './modules/customers';
import templates from './modules/templates';
import placements from './modules/placements';
import placementsTemplates from './modules/placements-templates';
import creativeStudio from './creative-studio';
import displayBuilder from './display-builder';
import pdpPromptSettings from './pdp-prompt-settings';
Vue.use(Vuex)

/**
 * Main Vuex Store
 */
const store = new Vuex.Store({
  modules: {
    project,
    template,
    media,
    sceneDialog,
    scenes,
    theme,
    audio,
    video,
    layout,
    dashboard,
    psdLayers,
    figmaLayers,
    fileBrowser,
    layoutFolderBrowser,
    fileBrowserProductSelector,
    fileUploadImages,
    svgEditor,
    productDescription,
    walmart,
    userNotification,
    bynder,
    productImageSelector,
    mobileHeroSettings,
    feedImportMapping,
    gridViewMemory,
    customers,
    templates,
    placements,
    placementsTemplates,
    creativeStudio,
    displayBuilder,
    pdpPromptSettings,
  },
  plugins: import.meta.env.DEV
      ? [StoreSaver]
      : []
})

export default store
